// extracted by mini-css-extract-plugin
export default {"header":"styles_header__Ppbhr","productsPage":"styles_productsPage__RB9Dr"};